<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection>
            <template #title>
                Session Information
            </template>
            
            <FormGroup
                name="spaces"
                label="Spaces">
                <Input
                    v-model="form.spaces"
                    name="spaces"
                    class="max-w-28"
                    placeholder="e.g. 20"/>
            </FormGroup>

            <div class="space-y-4">
                <template
                    v-for="(session, i) in form.course_sessions"
                    :key="`${session.course_session_group_id}-${session.module_id}`">

                    <hr v-if="i !== 0">
                    <div :class="{'relative pt-4 px-4 -mx-4 bg-gray-100 cursor-not-allowed sm:px-6 sm:-mx-6': (course.type == 1 ? session.disabled : null)}">
                        <h3 v-if="course.multipart" class="mb-4">
                            <span class="text-gray-500">Module: </span>
                            <span class="font-medium">{{ session.module_title }}</span>
                        </h3>
                        <SessionDates :name="`course_sessions.${i}`" :session="session" :disabled="session.disabled" :courseType="course.type"/>
                    </div>
                </template>
            </div>

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection";
import FormGroup from "@/Components/Form/FormGroup";
import Input from "@/Components/Form/Input";
import Select from "@/Components/Form/Select";
import File from "@/Components/Form/File";
import Textarea from "@/Components/Form/Textarea";
import InputError from "@/Components/Form/InputError";
import Label from "@/Components/Form/Label";
import Checkbox from "@/Components/Form/Checkbox";
import {ElDatePicker, ElTimeSelect} from "element-plus";
import dayjs from "dayjs";
import SessionDates from "@/Pages/Admin/CourseSessionGroups/Components/SessionDates";

export default {

    name: "CourseSessionGroupForm",

    props: {
        course: {
            type: Object,
            required: true
        }
    },

    emits: ['submit'],

    data() {
        return {
            types: [
                {label: "Zoom", value: "Zoom"},
                {label: "Face-to-face", value: "F2F"},
                {label: "E-Learning", value: "Elearning"},
            ],
            start: {
                date: null,
                time: null
            },
            end: {
                date: null,
                time: null
            }
        };
    },

    inject: ['form'],

    mounted() {
        this.setStartDate();
        this.setEndDate();
    },

    components: {
        FormSection,
        FormGroup,
        Input,
        Select,
        File,
        Textarea,
        Label,
        InputError,
        Checkbox,
        ElDatePicker,
        ElTimeSelect,
        SessionDates,
    },

    methods: {
        setStartDate() {
            const datetime = dayjs(this.form.start);

            this.start.date = datetime.isValid() ? datetime.format('YYYY-MM-DD') : null;
            this.start.time = datetime.isValid() ? datetime.format('HH:mm') : null;
        },
        setEndDate() {
            const datetime = dayjs(this.form.end);

            this.end.date = datetime.isValid() ? datetime.format('YYYY-MM-DD') : null;
            this.end.time = datetime.isValid() ? datetime.format('HH:mm') : null;
        },
        disabledStartDate(date) {
            return this.end.date ? dayjs(date).isAfter(dayjs(this.end.date).startOf('day')) : false;
        },
        disabledEndDate(date) {
            return this.start.date ? dayjs(date).isBefore(dayjs(this.start.date).startOf('day')) : false;
        },
    },

    watch: {
        'form.type'() {
            this.form.errors.clear('location_url');
            this.form.errors.clear('location_notes');
        },
        'form.start'() {
            this.form.errors.clear('start');
            this.form.errors.clear('end');
            this.setStartDate();
        },
        'form.end'() {
            this.form.errors.clear('start');
            this.form.errors.clear('end');
            this.setEndDate();
        },
        start: {
            deep: true,
            handler(start) {
                if (start.date && start.time) {
                    const date = dayjs(start.date);
                    const time = dayjs(start.time, 'HH:mm');

                    this.form.start = date
                        .hour(isNaN(time.hour()) ? 0 : time.hour())
                        .minute(isNaN(time.minute()) ? 0 : time.minute())
                        .second(0)
                        .toISOString();

                } else {
                    this.form.start = null;
                }
            }
        },
        end: {
            deep: true,
            handler(end) {
                if (end.date && end.time) {
                    const date = dayjs(end.date);
                    const time = dayjs(end.time, 'HH:mm');

                    this.form.end = date
                        .hour(isNaN(time.hour()) ? 0 : time.hour())
                        .minute(isNaN(time.minute()) ? 0 : time.minute())
                        .second(0)
                        .toISOString();

                } else {
                    this.form.end = null;
                }
            }
        },
    }
};

</script>
